import { graphql } from '../../gql';

export const CLIENT_MEMBERS_QUERY = graphql(`
  query UsageAnalyticsClientMembers($ids: [String]) {
    clients(ids: $ids) {
      client_name
      users {
        email
        username
      }
    }
  }
`);
